"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prices = void 0;
exports.prices = {
    find: {
        method: 'get',
        path: '/prices',
        response: {},
    },
    findByPropertyId: {
        method: 'get',
        path: '/prices/:propertyId',
        params: ['propertyId'],
        response: {},
    },
    getCancellationInsurancePrice: {
        method: 'post',
        dto: {},
        path: '/prices/cancellation-insurances',
        response: {},
    },
    getPriceListWithNoCursor: {
        method: 'get',
        path: '/prices/no-cursor',
        response: {},
    },
};
//# sourceMappingURL=prices.api.js.map